<template>
  <el-dialog
    width="800px"
    title="自定义订单报表导出"
    v-model="isvisible"
    v-if="isvisible"
    class="exportBox"
  >
    <div>
      <el-form
        ref="exportFormRef"
        :model="exportForm"
        label-width="120px"
        class="demo-ruleForm"
        status-icon
      >
        
          <h1>订单基本信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllOrder"
              :indeterminate="isIndeterminateOrder"
              @change="handleCheckAllChangeOrder"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerOrder" @change="handleCheckedChangeOrder">
          <ul>
            <li>
              <el-checkbox name="platformed" :checked="true" label="0||platformed||平台交易时间"
                >平台交易时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="created" :checked="true" label="0||created||垚旌导入时间"
                >垚旌导入时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="platformnum" :checked="true" label="0||platformnum||平台订单号"
                >平台订单号</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="ordernum" :checked="true" label="0||ordernum||垚旌订单号"
                >垚旌订单号</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="ordertype" :checked="true"  label="0||ordertype||订单类型"
                >订单类型</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="orderstatus" :checked="true"  label="0||orderstatus||订单状态"
                >订单状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="receiver" :checked="true" label="0||receiver||收货人姓名"
                >收货人姓名</el-checkbox
              >
            </li>
            <li>
              <el-checkbox
                name="receiverphone"
                :checked="true" 
                label="0||receiverphone||收货人电话"
                >收货人电话</el-checkbox
              >
            </li>
            <li>
              <el-checkbox
                name="receiveraddress"
                :checked="true" 
                label="0||receiveraddress||收货地址"
                >收货地址</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="completed" :checked="true" label="0||completed||订单完成时间"
                >订单完成时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="ordernote" :checked="true" label="0||ordernote||客户下单备注"
                >客户下单备注</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="abnormalstatus" :checked="true" label="0||abnormalstatus||异常订单状态"
                >异常订单状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="abnormalnote" :checked="true" label="0||abnormalnote||异常订单备注"
                >异常订单备注</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="abnormaled" :checked="true" label="0||abnormaled||异常订单备注时间"
                >异常订单备注时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="ordernote1" :checked="true" label="0||ordernote1||订单备注1"
                >订单备注1</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="ordernote2" :checked="true" label="0||ordernote2||订单备注2"
                >订单备注2</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="ordernote3" :checked="true" label="0||ordernote3||订单备注3"
                >订单备注3</el-checkbox
              >
            </li>
            <li>
              <el-checkbox name="orderidentifier" :checked="true" label="0||orderidentifier||订单标识"
                >订单标识</el-checkbox
              >
            </li>
          </ul>
        </el-checkbox-group>
          <h1>订单金额信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllAmount"
              :indeterminate="isIndeterminateAmount"
              @change="handleCheckAllChangeAmount"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerAmount" @change="handleCheckedChangeAmount">
          <ul>
            <li>
              <el-checkbox :checked="true" name="saleamount" label="1||saleamount||销售金额"
                >销售金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="costamount" label="1||costamount||成本金额"
                >成本金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="realqty" label="1||realqty||实发数量"
                >实发数量</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="maolieamount" label="1||maolieamount||毛利额"
                >毛利额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="maoliv" label="1||maoliv||毛利率"
                >毛利率</el-checkbox
              >
            </li>
            <li>
              <el-checkbox
                name="maolivstatus"
                :checked="true" 
                label="1||maolivstatus||毛利率状态"
                >毛利率状态</el-checkbox
              >
            </li>
          </ul>
          </el-checkbox-group>
          <h1>订单商品信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllGoods"
              :indeterminate="isIndeterminateGoods"
              @change="handleCheckAllChangeGoods"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerGoods" @change="handleCheckedChangeGoods">
          <ul>
            <li>
              <el-checkbox :checked="true" name="sgoodsnum" label="2||sgoodsnum||供应商商品ID"
                >供应商商品ID</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="goodsnum" label="2||goodsnum||商品ID"
                >商品ID</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="pname" label="2||pname||礼包商品名称"
                >礼包商品名称</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="name" label="2||name||商品名称"
                >商品名称</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="catalogname" label="2||catalogname||商品类目"
                >商品类目</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="brandname" label="2||brandname||商品品牌"
                >商品品牌</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="brandid" label="2||brandid||商品品牌ID"
                >商品品牌ID</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="typename" label="2||typename||商品类型"
                >商品类型</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="specification"
                label="2||specification||商品规格"
                >商品规格</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="giftsku" label="2||giftsku||礼包单品SKU编码"
                >礼包单品SKU编码</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="desc" label="2||desc||商品描述"
                >商品描述</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="taxcode" label="2||taxcode||税收编码"
                >税收编码</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="taxsort" label="2||taxsort||税收分类名称"
                >税收分类名称</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="barcode" label="2||barcode||国际条形码"
                >国际条形码</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="erate" label="2||erate||电商评价数"
                >电商评价数</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="elink" label="2||elink||电商链接"
                >电商链接</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="note1" label="2||note1||商品备注1"
                >商品备注1</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="note2" label="2||note2||商品备注2"
                >商品备注2</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="producer" label="2||producer||产地"
                >产地</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="delivery" label="2||delivery||发货地"
                >发货地</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="express" label="2||express||发货快递"
                >发货快递</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="expressdemand" label="2||expressdemand||发货快递要求"
                >发货快递要求</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="costprice" label="2||costprice||成本价"
                >成本价</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="marketprice" label="2||marketprice||市场价"
                >市场价</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="discount" label="2||discount||商品折扣"
                >商品折扣</el-checkbox
              >
            </li>
            
          </ul>
          </el-checkbox-group>
          <h1>订单发货信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllAddress"
              :indeterminate="isIndeterminateAddress"
              @change="handleCheckAllChangeAddress"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerAddress" @change="handleCheckedChangeAddress">
          <ul>
            <li>
              <el-checkbox :checked="true" name="expressnum" label="3||expressnum||快递单号"
                >快递单号</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="expresscompany"
                label="3||expresscompany||快递公司"
                >快递公司</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="deliveryed" label="3||deliveryed||发货时间"
                >发货时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="freightamount"
                label="3||freightamount||运费金额"
                >运费金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="deliverynote" label="3||deliverynote||后端处理备注"
                >后端处理备注</el-checkbox
              >
            </li>
          </ul>
          </el-checkbox-group>
          <h1>订单售后信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllSale"
              :indeterminate="isIndeterminateSale"
              @change="handleCheckAllChangeSale"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerSale" @change="handleCheckedChangeSale">
          <ul>
            <li>
              <el-checkbox :checked="true" name="applyed" label="4||applyed||申请时间"
                >申请时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="saletype" label="4||saletype||售后类型"
                >售后类型</el-checkbox
              >
            </li>
            <li style="display:none">
              <el-checkbox :checked="true" name="reason" label="4||reason||申请原因"
                >申请原因</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="salecompleted"
                label="4||salecompleted||售后完成时间"
                >售后完成时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="salestatus" label="4||salestatus||售后状态"
                >售后状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="supplieramount"
                label="4||supplieramount||供应商货款事宜"
                >供应商货款事宜</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="salenote" label="4||salenote||售后说明"
                >售后说明</el-checkbox
              >
            </li>
          </ul>
          </el-checkbox-group>

          <h1>客户信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllCustomer"
              :indeterminate="isIndeterminateCustomer"
              @change="handleCheckAllChangeCustomer"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerCustomer" @change="handleCheckedChangeCustomer">
          <ul>
            <li>
              <el-checkbox :checked="true" name="name" label="5||customername||客户"
                >客户</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="name" label="5||customerid||客户ID"
                >客户ID</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="name" label="5||customertype||客户类型"
                >客户类型</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="paidway" label="5||paidway||收款方式"
                >收款方式</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cuspaidamount"
                label="5||cuspaidamount||收款金额"
                >收款金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="paidaccount" label="5||paidaccount||收款账户"
                >收款账户</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="iscontract" label="5||ciscontract||有无合同"
                >有无合同</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="isaccount" label="5||cisaccount||账期"
                >账期</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cuspaided" label="5||cuspaided||客户对账时间"
                >客户对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cusistax" label="5||cusistax||有无开票"
                >有无开票</el-checkbox
              >
            </li>
            <!-- <li>
              <el-checkbox :checked="true" name="custaxtype" label="5||custaxtype||发票类型"
                >发票类型</el-checkbox
              >
            </li> -->
            <li>
              <el-checkbox :checked="true" name="taxpoint" label="5||ctaxpoint||开票税点"
                >开票税点</el-checkbox
              >
            </li>
          </ul>
          </el-checkbox-group>
          <h1>供应商信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllSupplier"
              :indeterminate="isIndeterminateSupplier"
              @change="handleCheckAllChangeSupplier"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerSupplier" @change="handleCheckedChangeSupplier">
          <ul>
            <li>
              <el-checkbox :checked="true" name="name" label="6||suppliername||供应商"
                >供应商</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="name" label="6||supplierid||供应商ID"
                >供应商ID</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="payway" label="6||payway||付款方式"
                >付款方式</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayamount" label="6||suppayamount||付款金额"
                >付款金额</el-checkbox
              >
            </li>
            <!-- <li>
              <el-checkbox :checked="true" name="payaccount" label="6||payaccount||付款账户"
                >付款账户</el-checkbox
              >
            </li> -->
            <li>
              <el-checkbox :checked="true" name="iscontract" label="6||siscontract||有无合同"
                >有无合同</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="isaccount" label="6||isaccount||账期"
                >账期</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayed" label="6||suppayed||供应商对账时间"
                >供应商对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="supistax" label="6||supistax||有无开票"
                >有无开票</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suptaxtype" label="6||suptaxtype||发票类型"
                >发票类型</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="taxpoint" label="6||staxpoint||开票税点"
                >开票税点</el-checkbox
              >
            </li>
          </ul>
          </el-checkbox-group>
          <h1>客户对账信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllCustomerVerify"
              :indeterminate="isIndeterminateCustomerVerify"
              @change="handleCheckAllChangeCustomerVerify"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerCustomerVerify" @change="handleCheckedChangeCustomerVerify">
          <ul>
            <li>
              <el-checkbox :checked="true" name="cusstatus" label="7||cusstatus||客户对账状态"
                >客户对账状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cuspaystatus" label="7||cuspaystatus||客户收款状态"
                >客户收款状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cuspaided" label="7||cuspaided||客户对账时间"
                >客户对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cuscompensation"
                label="7||cuscompensation||差异补偿金额"
                >差异补偿金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cussetstatus"
                label="7||cussetstatus||客户结算状态"
                >客户结算状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="cuspaidamount"
                label="7||cuspaidamount||应收金额"
                >应收金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cusistax" label="7||cusistax||收款开票"
                >收款开票</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="cusnote" label="7||cusnote||客户对账备注"
                >客户对账备注</el-checkbox
              >
            </li>
          </ul>
        </el-checkbox-group>
          <h1>供应商对账信息
            <el-checkbox
              style="margin-left:20px;"
              v-model="checkAllSupplierVerify"
              :indeterminate="isIndeterminateSupplierVerify"
              @change="handleCheckAllChangeSupplierVerify"
              >全选</el-checkbox
            >
          </h1>
          <el-checkbox-group v-model="exportForm.headerSupplierVerify" @change="handleCheckedChangeSupplierVerify">
          <ul>
            <li>
              <el-checkbox :checked="true" name="supstatus" label="8||supstatus||供应商对账状态"
                >供应商对账状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppaystatus" label="8||suppaystatus||供应商付款状态"
                >供应商付款状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayed" label="8||suppayed||供应商对账时间"
                >供应商对账时间</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="supcompensation"
                label="8||supcompensation||差异补偿金额"
                >差异补偿金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true"
                name="supsetstatus"
                label="8||supsetstatus||供应商结算状态"
                >供应商结算状态</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="suppayamount" label="8||suppayamount||应付金额"
                >应付金额</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="supistax" label="8||supistax||付款开票"
                >付款开票</el-checkbox
              >
            </li>
            <li>
              <el-checkbox :checked="true" name="supnote" label="8||supnote||供应商对账备注"
                >供应商对账备注</el-checkbox
              >
            </li>
          </ul>
        </el-checkbox-group>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doExportOrder('supplier')" :loading="loadingsupplier">{{
          loadingsupplier ? "处理中 ..." : "按供应商（全）导出"
        }}<el-tooltip content="一次最多导出5万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button>
        <el-button type="danger" v-if="exportExpressActionVal=='express1'" @click="doExportOrder('express')" :loading="loadingexpress">{{
          loadingexpress ? "处理中 ..." : "按快递单号导出"
        }}<el-tooltip content="一次最多导出5万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button>
        <el-button type="danger" @click="doExportOrder()" :loading="loading">{{
          loading ? "处理中 ..." : "常规导出"
        }}<el-tooltip content="一次最多导出5万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, onMounted, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { exportOrder, exportOrderSupplier, exportSaleOrder, exportSaleOrderSupplier, exportVerifyOrder, exportVerifyOrderSupplier } from "@/api/order";
// import util from "@/util/tool.js";

let timer;

const loading = ref(false);
const loadingsupplier = ref(false);
const loadingexpress = ref(false)

const emit = defineEmits(["click"]); // 声明父触发事件

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const exportFormRef = ref();
const exportForm = ref({
  headerOrder: [],
  headerAmount: [],
  headerGoods: [],
  headerAddress: [],
  headerSale: [],
  headerCustomer: [],
  headerSupplier: [],
  headerCustomerVerify: [],
  headerSupplierVerify: [],
  //header: [],
});

const checkAllOrder = ref(true)
const checkedOrder = ref(['0||platformed||平台交易时间','0||created||垚旌导入时间','0||platformnum||平台订单号','0||ordernum||垚旌订单号','0||ordertype||订单类型','0||orderstatus||订单状态','0||receiver||收货人姓名','0||receiverphone||收货人电话','0||receiveraddress||收货地址','0||completed||订单完成时间','0||ordernote||客户下单备注'])
const isIndeterminateOrder = ref(true)
const handleCheckAllChangeOrder = (val) => {
  exportForm.value.headerOrder = val ? checkedOrder.value : []
  isIndeterminateOrder.value = false
}
const handleCheckedChangeOrder = (value) => {
  const checkedCount = value.length
  checkAllOrder.value = checkedCount === checkedOrder.value.length
  isIndeterminateOrder.value = checkedCount > 0 && checkedCount < checkedOrder.value.length
}

const checkAllAmount = ref(true)
const checkedAmount = ref(['1||saleamount||销售金额','1||costamount||成本金额','1||realqty||实发数量','1||maolieamount||毛利额','1||maoliv||毛利率','1||maolivstatus||毛利率状态'])
const isIndeterminateAmount = ref(true)
const handleCheckAllChangeAmount = (val) => {
  exportForm.value.headerAmount = val ? checkedAmount.value : []
  isIndeterminateAmount.value = false
}
const handleCheckedChangeAmount = (value) => {
  const checkedCount = value.length
  checkAllAmount.value = checkedCount === checkedAmount.value.length
  isIndeterminateAmount.value = checkedCount > 0 && checkedCount < checkedAmount.value.length
}

const checkAllGoods = ref(true)
const checkedGoods = ref(['2||sgoodsnum||供应商商品ID','2||goodsnum||商品ID','2||name||商品名称','2||catalogname||商品类目','2||brandname||商品品牌','2||brandid||商品品牌ID','2||specification||商品规格','2||costprice||成本价','2||marketprice||市场价','2||discount||商品折扣'])
const isIndeterminateGoods = ref(true)
const handleCheckAllChangeGoods = (val) => {
  exportForm.value.headerGoods = val ? checkedGoods.value : []
  isIndeterminateGoods.value = false
}
const handleCheckedChangeGoods = (value) => {
  const checkedCount = value.length
  checkAllGoods.value = checkedCount === checkedGoods.value.length
  isIndeterminateGoods.value = checkedCount > 0 && checkedCount < checkedGoods.value.length
}

const checkAllAddress = ref(true)
const checkedAddress = ref(['3||expressnum||快递单号','3||expresscompany||快递公司','3||deliveryed||发货时间','3||freightamount||运费金额','3||deliverynote||后端处理备注'])
const isIndeterminateAddress = ref(true)
const handleCheckAllChangeAddress = (val) => {
  exportForm.value.headerAddress = val ? checkedAddress.value : []
  isIndeterminateAddress.value = false
}
const handleCheckedChangeAddress = (value) => {
  const checkedCount = value.length
  checkAllAddress.value = checkedCount === checkedAddress.value.length
  isIndeterminateAddress.value = checkedCount > 0 && checkedCount < checkedAddress.value.length
}

const checkAllSale = ref(true)
const checkedSale = ref(['4||applyed||申请时间','4||saletype||售后类型','4||reason||申请原因','4||salecompleted||售后完成时间','4||salestatus||售后状态','4||supplieramount||供应商货款事宜','4||salenote||售后说明'])
const isIndeterminateSale = ref(true)
const handleCheckAllChangeSale = (val) => {
  exportForm.value.headerSale = val ? checkedSale.value : []
  isIndeterminateSale.value = false
}
const handleCheckedChangeSale = (value) => {
  const checkedCount = value.length
  checkAllSale.value = checkedCount === checkedSale.value.length
  isIndeterminateSale.value = checkedCount > 0 && checkedCount < checkedSale.value.length
}

const checkAllCustomer = ref(true)
const checkedCustomer = ref(['5||customername||客户','5||customerid||客户ID','5||paidway||收款方式','5||cuspaidamount||收款金额','5||paidaccount||收款账户','5||ciscontract||有无合同','5||cisaccount||账期','5||cuspaided||客户对账时间','5||cusistax||有无开票','5||ctaxpoint||开票税点'])
const isIndeterminateCustomer = ref(true)
const handleCheckAllChangeCustomer = (val) => {
  exportForm.value.headerCustomer = val ? checkedCustomer.value : []
  isIndeterminateCustomer.value = false
}
const handleCheckedChangeCustomer = (value) => {
  const checkedCount = value.length
  checkAllCustomer.value = checkedCount === checkedCustomer.value.length
  isIndeterminateCustomer.value = checkedCount > 0 && checkedCount < checkedCustomer.value.length
}

const checkAllSupplier = ref(true)
// const checkedSupplier = ref(['6||suppliername||供应商','6||payway||付款方式','6||suppayamount||付款金额','6||payaccount||付款账户','6||siscontract||有无合同','6||isaccount||有无账期','6||suppayed||供应商对账时间','6||supistax||有无开票','6||suptaxtype||发票类型','6||staxpoint||开票税点'])
const checkedSupplier = ref(['6||suppliername||供应商','6||supplierid||供应商ID','6||payway||付款方式','6||suppayamount||付款金额','6||siscontract||有无合同','6||isaccount||账期','6||suppayed||供应商对账时间','6||supistax||有无开票','6||suptaxtype||发票类型','6||staxpoint||开票税点'])
const isIndeterminateSupplier = ref(true)
const handleCheckAllChangeSupplier = (val) => {
  exportForm.value.headerSupplier = val ? checkedSupplier.value : []
  isIndeterminateSupplier.value = false
}
const handleCheckedChangeSupplier = (value) => {
  const checkedCount = value.length
  checkAllSupplier.value = checkedCount === checkedSupplier.value.length
  isIndeterminateSupplier.value = checkedCount > 0 && checkedCount < checkedSupplier.value.length
}

const checkAllCustomerVerify = ref(true)
const checkedCustomerVerify = ref(['7||cusstatus||客户对账状态','7||cuspaided||客户对账时间','7||cuscompensation||差异补偿金额','7||cussetstatus||客户结算状态','7||cuspaidamount||应收金额','7||cusistax||收款开票','7||cusnote||客户对账备注'])
const isIndeterminateCustomerVerify = ref(true)
const handleCheckAllChangeCustomerVerify = (val) => {
  exportForm.value.headerCustomerVerify = val ? checkedCustomerVerify.value : []
  isIndeterminateCustomerVerify.value = false
}
const handleCheckedChangeCustomerVerify = (value) => {
  const checkedCount = value.length
  checkAllCustomerVerify.value = checkedCount === checkedCustomerVerify.value.length
  isIndeterminateCustomerVerify.value = checkedCount > 0 && checkedCount < checkedCustomerVerify.value.length
}

const checkAllSupplierVerify = ref(true)
const checkedSupplierVerify = ref(['8||supstatus||供应商对账状态','8||suppayed||供应商对账时间','8||supcompensation||差异补偿金额','8||supsetstatus||供应商结算状态','8||suppayamount||应付金额','8||supistax||付款开票','8||supnote||供应商对账备注'])
const isIndeterminateSupplierVerify = ref(true)
const handleCheckAllChangeSupplierVerify = (val) => {
  exportForm.value.headerSupplierVerify = val ? checkedSupplierVerify.value : []
  isIndeterminateSupplierVerify.value = false
}
const handleCheckedChangeSupplierVerify = (value) => {
  const checkedCount = value.length
  checkAllSupplierVerify.value = checkedCount === checkedSupplierVerify.value.length
  isIndeterminateSupplierVerify.value = checkedCount > 0 && checkedCount < checkedSupplierVerify.value.length
}

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: 10,
  platformed: "",
  platformnum: "",
  ordernum: "",
  name: "",
  customerid: "",
  supplierid: "",
  expressnum: "",
  receiver: "",
  receiverphone: "",
  maolivstatus: "",
  orderstatus: "",
  created: "",
  changed: "",
});

const exportOrderMethod = (obj) => {
  queryParam.value = obj;
  //console.log(queryParam.value);
};

const exportExpressActionVal = ref("order");//为了按快递单号导出

const exportActionVal = ref("order");
const exportAction = (v) => {
  console.log('-------v',v)
  exportActionVal.value = v;
  if (v == 'order') {
    //exportExpressActionVal.value = 'express'
  }
};
defineExpose({ changeVisible, exportAction, exportOrderMethod });

const doExportOrder = (type) => {
  let headerTmp = [];

  // headerOrder: [],
  // headerAmount: [],
  // headerAddress: [],
  // headerSale: [],
  // headerCustomer: [],
  // headerSupplier: [],
  // headerCustomerVerify: [],
  // headerSupplierVerify: [],

  // let header = exportForm.value.header;

  let header = [...exportForm.value.headerOrder,...exportForm.value.headerAmount,...exportForm.value.headerGoods,...exportForm.value.headerAddress,...exportForm.value.headerSale,...exportForm.value.headerCustomer,...exportForm.value.headerSupplier,...exportForm.value.headerCustomerVerify,...exportForm.value.headerSupplierVerify]

  if (type == 'express') {////按快递单号导出，固定表头
    header = ['0||platformnum||平台订单号', '0||ordernum||垚旌订单号', '0||ordertype||订单类型','5||customername||客户','2||name||商品名称', '2||specification||商品规格', '3||expresscompany||快递公司', '3||expressnum||快递单号'];
    exportExpressActionVal.value = 'express';
    loadingexpress.value = true;
  }
  if (!type) {
    loading.value = true;
  }
  console.log('---type',type)

  header.forEach((item) => {
    let itemTmp = item.split("||");
    headerTmp.push({ index: itemTmp[0], name: itemTmp[1], value: itemTmp[2] });
  });
  //console.log('---headerTmp',headerTmp)

  exportFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    if (headerTmp.length <= 0) {
      ElMessage.error("请先选择要导出的字段！");
      return;
    }
    queryParam.value.pageSize = 20;

    //console.log(queryParam.value.customerid)
    let query = JSON.parse(JSON.stringify(queryParam.value)); 
    query.supplierids = query.supplierid?query.supplierid.join(','):''
    query.customerids = query.customerid?query.customerid.join(','):''
    delete query.customerid
    delete query.supplierid
    //console.log(query)

    
    if (type == 'supplier') {//按供应商导出
      exportActionVal.value = exportActionVal.value+'supplier';
      loadingsupplier.value = true;
    }

    let data = {
      order: query,//queryParam.value
      header: headerTmp,
    };


    if (exportActionVal.value == "order" || exportActionVal.value == "express") {
      exportOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (exportActionVal.value == "sale") {
      exportSaleOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (exportActionVal.value == "verify") {
      exportVerifyOrder(data).then((response) => {
        downloadExcel(response);
      });
    } else if (exportActionVal.value == "ordersupplier") {//按供应商导出
      exportOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    } else if (exportActionVal.value == "salesupplier") {
      exportSaleOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    } else if (exportActionVal.value == "verifysupplier") {
      exportVerifyOrderSupplier(data).then((response) => {
        downloadZip(response);
      });
    }
  });
};

const downloadExcel = (response) => {
  console.log('-exportExpressActionVal.value:',exportExpressActionVal.value)
  console.log('-exportActionVal.value:',exportActionVal.value)
  if (exportExpressActionVal.value == 'express') {
    loadingexpress.value = true;
  } else {
    loading.value = true;
  }
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      if (exportExpressActionVal.value == 'express') {
        loadingexpress.value = false;
      } else {
        loading.value = false;
      }
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    exportForm.value.header = [];
    closeDialog();
    emit("click");
  }, 1000);
};

const downloadZip = (response) => {
  loadingsupplier.value = true;
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingsupplier.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/zip"
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    exportForm.value.header = [];
    closeDialog();
    emit("click");
  }, 1000);
};

const closeDialog = () => {
  isvisible.value = false;
  exportFormRef.value.resetFields();
  clearTimeout(timer);
};

//onMounted方法
onMounted(() => {});
</script>
<style scoped>
.exportBox .el-dialog__body {
  padding-top: 0;
}
.exportBox .el-checkbox__label {
  font-weight: normal;
}
.exportBox div {
  max-height: 500px;
  overflow-y: auto;
}
.exportBox h1 {
  font-weight: normal;
  font-size: 18px;
  border-left: 2px solid #ff4849;
  border-radius: 2px;
  padding-left: 10px;
  line-height: 1;
}
.exportBox ul {
  padding: 0;
  margin: 0 0 35px 0;
  display: block;
}
.exportBox li {
  list-style: none;
  display: inline-block;
  width: 130px;
}
</style>